import { AgenticFlowByline } from '@agentic-flow-studio/shared/components/agentic-flow-byline';
import { completeOAuthBridge } from '@agentic-flow-studio/shared/lib/betterAuthClient';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PublicBrand } from '@/components/public-brand';

/**
 * Landing point for Google sign-in (see shared/src/lib/betterAuthClient.ts's signInWithGoogle /
 * oauth-bridge). Reads the session token the backend's bridge handed back via the URL fragment,
 * then continues on to wherever the user was headed.
 */
export default function OAuthComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const result = completeOAuthBridge('skill-viper');
    if (result.success) {
      navigate(searchParams.get('redirect') || '/dashboard', { replace: true });
    } else {
      setError(result.error || 'Google sign-in failed. Please try again.');
    }
  }, [navigate, searchParams]);

  return (
    <main className="min-h-screen flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center gap-8 p-6">
        <PublicBrand />
        {error ? (
          <div className="text-center space-y-4">
            <p className="text-sm text-destructive">{error}</p>
            <button
              onClick={() => navigate('/login')}
              className="text-sm font-medium text-primary hover:underline"
            >
              Back to login
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="text-sm text-muted-foreground">Finishing sign-in...</p>
          </div>
        )}
        <AgenticFlowByline />
      </div>
    </main>
  );
}
